import classNames from 'classnames';
import { ReactNode } from 'react';

export interface Props {
  className?: string;
  children: ReactNode;
}

export const PaymentStatusWrapper = ({ className, children }: Props) => {
  return (
    <h2
      className={classNames('d-inline-flex u-fs-6', className)}
      data-ghost="portal-loan--payment-header-status"
      data-testid="payment-header-status"
    >
      {children}
    </h2>
  );
};
